import Auth from '@/api/auth';
import { createNamespacedHelpers } from 'vuex';

import IconArchive from '@/assets/icons/archive.svg';
import IconChats from '@/assets/icons/chats.svg';
import IconBooking from '@/assets/icons/booking.svg';
import IconAnalytics from '@/assets/icons/analytics.svg';
import IconConcierges from '@/assets/icons/concierges.svg';
import IconPayment from '@/assets/icons/payment.svg';
import IconGuide from '@/assets/icons/guide.svg';
import IconSettings from '@/assets/icons/settings.svg';
import IconDashboard from '@/assets/icons/dashboard.svg';

import Config from '@/config';

const { mapState: mapChannelState } = createNamespacedHelpers('Channel');
const { mapState: mapConciergeState } = createNamespacedHelpers('Concierge');

export default {
  name: 'SideBar',
  components: {
    IconArchive,
    IconChats,
    IconBooking,
    IconAnalytics,
    IconConcierges,
    IconPayment,
    IconGuide,
    IconSettings,
    IconDashboard
  },
  data: () => ({
    version: Config.Version
  }),

  computed: {
    ...mapChannelState({
      ownChannels: state => state.ownChannels,

      ownChannelAlias: 'ownChannels',

      getOwnChannelCount: function(state) {
        return state.ownChannels.length;
      }
    }),

    ...mapConciergeState({
      profilePhoto: state => state.currentConcierge.profilePhoto
    })

    // INFO: You can add your own function, or other mapState
  },
  methods: {
    logoutConcierge: function() {
      Auth.logoutConcierge();
      this.$router.push({ name: 'Root' });
    }
  }
};
